import React, { useEffect, useState, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"

const services = [
  {
    id: 1,
    title: "Huge audience:",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content1:
      " Facebook has a massive user base, making it an ideal platform for businesses to reach their target audience.",
  },
  {
    id: 2,
    title: "Targeted advertising:",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    content1:
      "Facebook's advertising platform allows businesses to target specific audiences based on demographics, interests, and behaviors.",
  },
  {
    id: 3,
    title: "  Cost-effective:",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    content1:
      " Facebook marketing can be more cost-effective than traditional forms of advertising.",
  },
  {
    id: 4,
    title: "Measurable results",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    content1:
      "Facebook provides businesses with measurable results, including engagement metrics, conversion tracking, and return on ad spend.",
  },
  {
    id: 5,
    title: " Increased brand awareness",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content1:
      "Facebook marketing can help businesses increase brand awareness and establish themselves as industry leaders.",
  },
];
const SocialFbAni = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px 0px -60% 0px", // triggers earlier when top is at 40% of viewport
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.getAttribute("data-index"));
          setActiveIndex(index);
        }
      });
    }, options);

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div>
      <div className="">
        <div className="benefitsfont">benefits</div>
        <div className="benefithead">Facebook Marketing</div>
        <div className="mb-5">
                       <div className="container-fluid">
                         <div className="row">
                           <div className="col-lg-12">
                             <div className="benefitwidth">
                               <OwlCarousel
                                 className="owl-theme"
                                 loop
                                 autoplay={true}
                                 items="1"
                                 dots={false}
                                 smartSpeed={2000}
                                 nav={true}
                                 navText={[
                                   `<i class="fa fa-chevron-left"></i>`,
                                   `<i class="fa fa-chevron-right"></i>`,
                                 ]}
                                 margin={20}
                                 // center={true}
                                 autoplayTimeout={5000}
                                 responsive={{
                                   360: {
                                     items: "1",
                                   },
                                   414: {
                                     items: "1",
                                   },
                                   670: {
                                     items: "2",
                                   },
                                   992: {
                                     items: "3",
                                   },
         
                                   1200: {
                                     items: "3",
                                   },
                                 }}
                               >
                                 {services.map((item, index) => {
                                   return (
                                    <div className="position-circle">
                                       <img  src={benefiticon} className='benefiticon' alt='icon'/>
                                       <div className="border-dot1">
                                    <div className="orange-circle">
          
                                    </div>
                                    </div>
                                    <div className="carousel-wapp-card">
                                     
    <div>
      <div className="carouselwapp">
    {item.title}
      </div>
      <div className="carousel-para">
    {item.content1}
      </div>
    </div>
    
                                    </div>
                                    </div>
                                    
                                   );
                                 })}
                               </OwlCarousel>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
      </div>
    </div>
  );
};

export default SocialFbAni;
